import filterByUnfilled from './filterByUnfilled';
import sortByDocumentPosition from './sortByDocumentPosition';
import mapToIds from './mapToIds';

const getSortedUnfilledPopupIds = (popups, activePopup = null) =>
  mapToIds(sortByDocumentPosition(filterByUnfilled(Object.values(popups), activePopup)));

export default getSortedUnfilledPopupIds;



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/getSortedUnfilledPopupIds.jsx